module.exports = __webpack_public_path__ + "img/service-smart.ed07c25.png";